import { render, staticRenderFns } from "./VideoBackground.vue?vue&type=template&id=70e440cc&scoped=true&"
import script from "./VideoBackground.vue?vue&type=script&lang=js&"
export * from "./VideoBackground.vue?vue&type=script&lang=js&"
import style0 from "./VideoBackground.vue?vue&type=style&index=0&id=70e440cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e440cc",
  null
  
)

export default component.exports